import { useEffect, useState } from 'react'
import HozpitalizationApiInvoker from '../../../api/HospitalizationApiInvoker'
import { browserHistory } from 'react-router'

export const useHospitalizationForm = (props: any) => {
  const [dataPatient, setDataPatient] = useState<any>('')
  const [personId, setPersonId] = useState(null)
  const [dataFinance, setDataFinance] = useState('')
  const [dataHospitalization, setDataHospitalization] = useState<any>('')
  const [dataDischarge, setDataDischarge] = useState<any>('')
  const [showDischargeForm, setShowDischargeForm] = useState('')
  const [isValidatedPatientForm, setIsValidatedPatientForm] = useState(false)
  const [isValidatedFinanceForm, setIsValidatedFinanceForm] = useState(false)
  const [isValidatedDischargeForm, setIsValidatedDischargeForm] =
    useState(false)
  const [isValidatedHospitalizationForm, setIsValidatedHospitalizationForm] =
    useState(false)
  const [isValidatedAllForm, setIsValidatedAllForm] = useState(false)
  const [showSnackBar, setShowSnackBar] = useState(false)
  const [loading, setLoading] = useState(false)
  const [colorSnackBar, setColorSnackBar] = useState<string | null>(null)
  const [messageSnackBar, setMessageSnackBar] = useState<string | null>(null)
  const [validateFrequencyError, setValidateFrequencyError] = useState(false)

  const [dataPatientEdit, setDataPatientEdit] = useState<any>(null)
  const [dataHospitalizationEdit, setDataHospitalizationEdit] =
    useState<any>(null)
  const [dataDischargeEdit, setDataDischargeEdit] = useState<any>(null)
  const [axaInternmentId, setAxaInternmentId] = useState(null)

  const [save, setSave] = useState(false)

  const id = props.params.id
  const readOnly = props?.location?.state?.readOnly

  const onSave = () => {
    let dataForm = SetData('CREATED')
    if (id) {
      setLoading(true)
      setSave(false)
      HozpitalizationApiInvoker.updateAxaInternment(
        dataForm,
        (response: any) => {
          if (response) {
            setShowSnackBar(true)
            setColorSnackBar('success')
            setMessageSnackBar('Los cambios se guardaron exitosamente')
            setLoading(false)
            setTimeout(function () {
              setShowSnackBar(false)
              goToAdmissionList()
            }, 2000)
          }
        },
        (error: any) => {
          setShowSnackBar(true)
          setColorSnackBar('danger')
          setMessageSnackBar('Hubo un error al intentar guardar los cambios.')
          setLoading(false)
          setTimeout(function () {
            setShowSnackBar(false)
          }, 5000)
        }
      )
    } else {
      setLoading(true)
      setSave(false)
      HozpitalizationApiInvoker.postDischargeData(
        dataForm,
        (response: any) => {
          if (response) {
            setShowSnackBar(true)
            setColorSnackBar('success')
            setMessageSnackBar('Los cambios se guardaron exitosamente')
            setLoading(false)
            setTimeout(function () {
              setShowSnackBar(false)
              goToAdmissionList()
            }, 2000)
          }
        },
        (error: any) => {
          setShowSnackBar(true)
          setColorSnackBar('danger')
          setMessageSnackBar('Hubo un error al intentar guardar los cambios.')
          setLoading(false)
          setTimeout(function () {
            setShowSnackBar(false)
          }, 5000)
        }
      )
    }
  }

  const onRegister = () => {
    setSave(true)
    let dataForm = SetData('ENDED')
    setSave(false)
    HozpitalizationApiInvoker.updateAxaInternment(
      dataForm,
      (response: any) => {
        setShowSnackBar(true)
        setColorSnackBar('success')
        setMessageSnackBar('Se dio de alta la hospitalización exitosamente.')
        setLoading(false)
        setTimeout(function () {
          setShowSnackBar(false)
          goToAdmissionList()
        }, 3000)
      },
      (error: any) => {
        setShowSnackBar(true)
        setColorSnackBar('danger')
        setMessageSnackBar('Hubo un error al intentar guardar los cambios.')
        setLoading(false)
        setTimeout(function () {
          setShowSnackBar(false)
        }, 5000)
      }
    )
  }

  const goToAdmissionList = () => browserHistory.push('/admission')

  const SetData = (status: any) => {
    let userId = window.localStorage.getItem('user_id')
    let userName = window.localStorage.getItem('username')
    let data = {
      internmentStatus: status,
      axaInternmentId: id ? axaInternmentId : '',
      userId: userId,
      userName: userName,
      patientId: {
        personId: parseInt(dataPatient.patient),
      },
      axaServicesCenterId: {
        axaServicesCenterId: dataHospitalization.service_center,
      },
      room: dataHospitalization.room,
      therapy: dataHospitalization.therapy,
      admission_date: dataHospitalization.date_admission,
      egress_date: dataHospitalization.egress_date,
      treatingMedicalsId: dataHospitalization.treating_doctors
        ? {
            treatingMedicalsId: dataHospitalization.treating_doctors,
          }
        : null,
      historyPathologyList: dataHospitalization.history_of_pathology,
      admissionPathologyList: dataHospitalization.admission_diagnosis,
      dischargePathologyList: dataHospitalization.discharge_diagnosis,
      internmentKatz: dataDischarge.internmentKatz,
      barthelIndexId: dataDischarge.barthel_index,
      hospitalizationNewsList: dataHospitalization.hospitalizationNewsList,
      dischargePlaceId: dataHospitalization
        ? dataHospitalization.dischargePlace
        : null,
      medicalRecord: dataDischarge.clinical_history_summary,
      nursing: dataDischarge ? dataDischarge.nursing : false,
      nursingFrequency: dataDischarge ? dataDischarge.nursing_frequency : null,
      kinesiology: dataDischarge ? dataDischarge.kinesiology : false,
      kinesiology_frequency: dataDischarge
        ? dataDischarge.kinesiology_frequency
        : null,
      speechTherapy: dataDischarge ? dataDischarge.speechTherapy : false,
      speechTherapy_frequency: dataDischarge
        ? dataDischarge.speechTherapy_frequency
        : null,
      occupationalTherapy: dataDischarge
        ? dataDischarge.occupationalTherapy
        : false,
      occupationalTherapy_frequency: dataDischarge
        ? dataDischarge.occupationalTherapy_frequency
        : null,
      psychology: dataDischarge ? dataDischarge.psychology : false,
      psychology_frequency: dataDischarge
        ? dataDischarge.psychology_frequency
        : null,
      homeAssistant: dataDischarge ? dataDischarge.homeAssistant : false,
      homeAssistant_frequency: dataDischarge
        ? dataDischarge.homeAssistant_frequency
        : null,
      healing: dataDischarge ? dataDischarge.curations : false,
      healing_frequency: dataDischarge
        ? dataDischarge.curations_frequency
        : null,
      dressingsTypeId: dataDischarge ? dataDischarge.dressings_type : null,
      wheelchair: dataDischarge ? dataDischarge.wheelchair : false,
      orthopedic_bed: dataDischarge ? dataDischarge.orthopedic_bed : false,
      walkerno: dataDischarge ? dataDischarge.walker : false,
      oxygenConcentrator5Liter: dataDischarge
        ? dataDischarge.oxygenConcentrator5Liter
        : false,
      oxygenConcentrator10Liter: dataDischarge
        ? dataDischarge.oxygenConcentrator10Liter
        : false,
      medicineList: dataDischarge ? dataDischarge.medicineList : [],
    }
    return data
  }

  const setEditData = (id: any) => {
    HozpitalizationApiInvoker.getAxaInternmentById(id, (response: any) => {
      setAxaInternmentId(response[0].axaInternmentId)
      setDataPatientEdit({
        patient: response[0].patientId.personId,
        identification: response[0].patientId.id,
        direction: response[0].patientId.address.length
          ? response[0].patientId.address[0].addressId
          : null,
        zone: response[0].patientId.address.length
          ? response[0].patientId.address[0].geographicZone.detail
          : null,
        location: response[0].patientId.address.length
          ? response[0].patientId.address[0].location.name
          : null,
        province: response[0].patientId.address.length
          ? response[0].patientId.address[0].geographicZone.location.name
          : null,
        doctor: response[0].patientId.generalPractitionerId
          ? response[0].patientId.generalPractitionerId.generalPractitionerId
          : '',
        medicalRecord: response[0].patientId.generalPractitionerId
          ? response[0].patientId.generalPractitionerId
              .medicalRegistrationNumber
          : '',
      })
      setDataHospitalizationEdit({
        serviceCenter: response[0].axaServicesCenterId.axaServicesCenterId,
        therapy: response[0].therapy,
        room: response[0].room,
        dateAdmission: response[0].admission_date,
        egressDate: response[0].egress_date,
        treatingMedicalsId: response[0].treatingMedicalsId.treatingMedicalsId,
        historyPathology: response[0].historyPathologyList,
        admissionPathology: response[0].admissionPathologyList,
        dischargePathology: response[0].dischargePathologyList,
        hospitalizationNewsList: response[0].hospitalizationNewsList,
        dischargePlaceId: response[0].dischargePlaceId
          ? response[0].dischargePlaceId.dischargePlaceId
          : response[0].dischargePlaceId,
      })
      setDataDischargeEdit({
        medicalRecord: response[0].medicalRecord,
        nursing: response[0].nursing,
        nursing_frequency: response[0].nursingFrequency
          ? response[0].nursingFrequency.frequencyRangesId
          : null,
        kinesiology: response[0].kinesiology,
        kinesiology_frequency: response[0].kinesiology_frequency
          ? response[0].kinesiology_frequency.frequencyRangesId
          : null,
        speechTherapy: response[0].speechTherapy,
        speechTherapy_frequency: response[0].speechTherapy_frequency
          ? response[0].speechTherapy_frequency.frequencyRangesId
          : null,
        occupationalTherapy: response[0].occupationalTherapy,
        occupationalTherapy_frequency: response[0].occupationalTherapy_frequency
          ? response[0].occupationalTherapy_frequency.frequencyRangesId
          : null,
        psychology: response[0].psychology,
        psychology_frequency: response[0].psychology_frequency
          ? response[0].psychology_frequency.frequencyRangesId
          : null,
        homeAssistant: response[0].homeAssistant,
        homeAssistant_frequency: response[0].homeAssistant_frequency
          ? response[0].homeAssistant_frequency.frequencyRangesId
          : null,
        healing: response[0].healing,
        healing_frequency: response[0].healing_frequency
          ? response[0].healing_frequency.frequencyRangesId
          : null,
        dressingsTypeId: response[0].dressingsTypeId
          ? response[0].dressingsTypeId.dressingsTypeId
          : response[0].dressingsTypeId,
        wheelchair: response[0].wheelchair,
        orthopedic_bed: response[0].orthopedic_bed,
        walkerno: response[0].walkerno,
        oxygenConcentrator5Liter: response[0].oxygenConcentrator5Liter,
        oxygenConcentrator10Liter: response[0].oxygenConcentrator10Liter,
        medicineList: response[0].medicineList,
        internmentKatz: response[0].internmentKatz,
        barthelIndexId: response[0].barthelIndexId.recordId,
      })
    })
  }

  const switchToSave = (option: string) => {
    switch (option) {
      case 'register':
        onRegister()
        break

      case 'save':
        onSave()
        break

      default:
        break
    }
  }

  const validateForm = (option: any) => {
    setSave(true)
    if (
      isValidatedPatientForm &&
      isValidatedFinanceForm &&
      isValidatedHospitalizationForm &&
      showDischargeForm &&
      isValidatedDischargeForm &&
      validateFrequencyError
    ) {
      switchToSave(option)
    } else if (
      isValidatedPatientForm &&
      isValidatedFinanceForm &&
      isValidatedHospitalizationForm &&
      !showDischargeForm
    ) {
      switchToSave(option)
    } else if (
      isValidatedPatientForm &&
      isValidatedFinanceForm &&
      isValidatedHospitalizationForm &&
      showDischargeForm &&
      !isValidatedDischargeForm
    ) {
      setShowSnackBar(true)
      setColorSnackBar('warning')
      setMessageSnackBar(
        'Hay campos requeridos sin información. Complete todos los datos requeridos.'
      )
      setLoading(false)
      setTimeout(function () {
        setShowSnackBar(false)
      }, 3000)
    } else if (
      isValidatedPatientForm &&
      isValidatedFinanceForm &&
      isValidatedHospitalizationForm &&
      showDischargeForm &&
      !validateFrequencyError
    ) {
      setShowSnackBar(true)
      setColorSnackBar('warning')
      setLoading(false)
      setTimeout(function () {
        setShowSnackBar(false)
      }, 3000)
      setMessageSnackBar(
        'Falta escoger una frecuencia semanal para aquella indicaciones afirmativas.'
      )
    } else {
      setShowSnackBar(true)
      setColorSnackBar('warning')
      setMessageSnackBar(
        'Hay campos requeridos sin información. Complete todos los datos requeridos.'
      )
      setLoading(false)
      setTimeout(function () {
        setShowSnackBar(false)
      }, 3000)
    }
  }

  const setDataPatientForm = (data: any) => {
    setDataPatient(data)
  }

  const setDataFinanceForm = (data: any) => {
    setDataFinance(data)
  }

  const setDataHospitalizationtForm = (data: any) => {
    setDataHospitalization(data)
  }

  const setDataDischargeForm = (data: any) => {
    setDataDischarge(data)
  }

  const validationShowDischargeForm = (value: any) => {
    setShowDischargeForm(value)
  }

  const validateform = () => {
    setIsValidatedAllForm(
      isValidatedHospitalizationForm &&
        isValidatedFinanceForm &&
        isValidatedDischargeForm
    )
  }

  useEffect(() => {
    if (id) {
      setEditData(id)
    }
  }, [])

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    validateform()
  }, [
    isValidatedPatientForm,
    isValidatedFinanceForm,
    isValidatedHospitalizationForm,
    dataFinance,
    showSnackBar,
    dataHospitalization,
    dataDischarge,
    loading,
    validateFrequencyError,
  ])
  return {
    loading,
    dataDischarge,
    validateFrequencyError,
    isValidatedHospitalizationForm,
    dataDischargeEdit,
    showDischargeForm,
    dataHospitalizationEdit,
    id,
    personId,
    colorSnackBar,
    messageSnackBar,
    showSnackBar,
    save,
    dataPatientEdit,
    setValidateFrequencyError,
    goToAdmissionList,
    setDataDischargeForm,
    setIsValidatedDischargeForm,
    setPersonId,
    setIsValidatedHospitalizationForm,
    setDataHospitalizationtForm,
    validationShowDischargeForm,
    setIsValidatedPatientForm,
    setDataPatientForm,
    validateForm,
    setIsValidatedFinanceForm,
    setDataFinanceForm,
    switchToSave,
    readOnly
  }
}
